import { Component } from '@angular/core';
import { NavigationComponent } from '@features/navigation/components/navigation/navigation.component';
import { UserLoginComponent } from '@features/user/components/user-login/user-login.component';

@Component({
    selector: 'app-user-login-page',
    templateUrl: './user-login-page.component.html',
    imports: [UserLoginComponent, NavigationComponent],
})
export class UserLoginPageComponent {}
